// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import AuditAction from "./audit-action.js"
import School from "./school.js"
import SchoolClass from "./school-class.js"
import SurveyStepElement from "./survey-step-element.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "audited_changes": {
      "column": {
        "default": null,
        "name": "audited_changes",
        "null": true,
        "type": "text"
      },
      "name": "audited_changes",
      "selected_by_default": null,
      "translated": null
    },
    "auditable": {
      "column": null,
      "name": "auditable",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "current_school_id": {
      "column": {
        "default": null,
        "name": "current_school_id",
        "null": true,
        "type": null
      },
      "name": "current_school_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_school_class_id": {
      "column": {
        "default": null,
        "name": "current_school_class_id",
        "null": true,
        "type": null
      },
      "name": "current_school_class_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_user_id": {
      "column": {
        "default": null,
        "name": "current_user_id",
        "null": true,
        "type": null
      },
      "name": "current_user_id",
      "selected_by_default": null,
      "translated": null
    },
    "extra_liquid_variables": {
      "column": {
        "default": null,
        "name": "extra_liquid_variables",
        "null": true,
        "type": "text"
      },
      "name": "extra_liquid_variables",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "params": {
      "column": {
        "default": null,
        "name": "params",
        "null": true,
        "type": "text"
      },
      "name": "params",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "survey_step_element_id": {
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      },
      "name": "survey_step_element_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SurveyStepElement::Audit",
  "collectionKey": "survey_step_element/audits",
  "collectionName": "survey_step_element_audits",
  "i18nKey": "survey_step_element/audit",
  "camelizedLower": "surveyStepElement::Audit",
  "name": "SurveyStepElementAudit",
  "nameDasherized": "survey-step-element-audit",
  "pluralName": "survey_step_element_audits",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::AuditAction",
      "collectionName": "audit_actions",
      "foreignKey": "audit_action_id",
      "name": "audit_action",
      "macro": "belongs_to",
      "resource_name": "AuditAction",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "auditable",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "current_school_id",
      "name": "current_school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "current_school_class_id",
      "name": "current_school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "current_user_id",
      "name": "current_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "audit_action_id",
      "column": {
        "default": null,
        "name": "audit_action_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "audited_changes",
      "column": {
        "default": null,
        "name": "audited_changes",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_school_class_id",
      "column": {
        "default": null,
        "name": "current_school_class_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_school_id",
      "column": {
        "default": null,
        "name": "current_school_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_user_id",
      "column": {
        "default": null,
        "name": "current_user_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "extra_liquid_variables",
      "column": {
        "default": null,
        "name": "extra_liquid_variables",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "params",
      "column": {
        "default": null,
        "name": "params",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "survey_step_element_id",
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ActiveRecordAuditable::AuditAction",
      "collectionName": "audit_actions",
      "foreignKey": "audit_action_id",
      "name": "audit_action",
      "macro": "belongs_to",
      "resource_name": "AuditAction",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "current_school_id",
      "name": "current_school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "current_school_class_id",
      "name": "current_school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "current_user_id",
      "name": "current_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    }
  ],
  "paramKey": "survey_step_element_audit",
  "primaryKey": "id"
}

/** Frontend model for SurveyStepElementAudit. */
export default class SurveyStepElementAudit extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  auditedChanges() {
    return this.readAttributeUnderscore("audited_changes")
  }

  /** @returns {boolean} */
  hasAuditedChanges() {
    const value = this.auditedChanges()

    return this._isPresent(value)
  }

  /** @returns {any} */
  auditable() {
    return this.readAttributeUnderscore("auditable")
  }

  /** @returns {boolean} */
  hasAuditable() {
    const value = this.auditable()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentSchoolId() {
    return this.readAttributeUnderscore("current_school_id")
  }

  /** @returns {boolean} */
  hasCurrentSchoolId() {
    const value = this.currentSchoolId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentSchoolClassId() {
    return this.readAttributeUnderscore("current_school_class_id")
  }

  /** @returns {boolean} */
  hasCurrentSchoolClassId() {
    const value = this.currentSchoolClassId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentUserId() {
    return this.readAttributeUnderscore("current_user_id")
  }

  /** @returns {boolean} */
  hasCurrentUserId() {
    const value = this.currentUserId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  extraLiquidVariables() {
    return this.readAttributeUnderscore("extra_liquid_variables")
  }

  /** @returns {boolean} */
  hasExtraLiquidVariables() {
    const value = this.extraLiquidVariables()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  params() {
    return this.readAttributeUnderscore("params")
  }

  /** @returns {boolean} */
  hasParams() {
    const value = this.params()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyStepElementId() {
    return this.readAttributeUnderscore("survey_step_element_id")
  }

  /** @returns {boolean} */
  hasSurveyStepElementId() {
    const value = this.surveyStepElementId()

    return this._isPresent(value)
  }

  /** @returns {import("./audit-action.js").default | null} */
  auditAction() {
    return this._readBelongsToReflection({modelClass: AuditAction, reflectionName: "audit_action"})
  }

  /** @returns {Promise<import("./audit-action.js").default | null>} */
  loadAuditAction() {
    if (!("auditActionId" in this)) throw new Error("Foreign key method wasn't defined: auditActionId")

    const id = this.auditActionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "audit_action",
        model: this,
        modelClass: AuditAction
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./audit-action.js").default | null>} */
  ensureAuditActionLoaded() {
    return this.ensureAssociationLoaded("audit_action")
  }

  /** @returns {import("./school.js").default | null} */
  currentSchool() {
    return this._readBelongsToReflection({modelClass: School, reflectionName: "current_school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadCurrentSchool() {
    if (!("currentSchoolId" in this)) throw new Error("Foreign key method wasn't defined: currentSchoolId")

    const id = this.currentSchoolId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_school",
        model: this,
        modelClass: School
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  ensureCurrentSchoolLoaded() {
    return this.ensureAssociationLoaded("current_school")
  }

  /** @returns {import("./school-class.js").default | null} */
  currentSchoolClass() {
    return this._readBelongsToReflection({modelClass: SchoolClass, reflectionName: "current_school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadCurrentSchoolClass() {
    if (!("currentSchoolClassId" in this)) throw new Error("Foreign key method wasn't defined: currentSchoolClassId")

    const id = this.currentSchoolClassId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_school_class",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureCurrentSchoolClassLoaded() {
    return this.ensureAssociationLoaded("current_school_class")
  }

  /** @returns {import("./user.js").default | null} */
  currentUser() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "current_user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadCurrentUser() {
    if (!("currentUserId" in this)) throw new Error("Foreign key method wasn't defined: currentUserId")

    const id = this.currentUserId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureCurrentUserLoaded() {
    return this.ensureAssociationLoaded("current_user")
  }

  /** @returns {import("./survey-step-element.js").default | null} */
  surveyStepElement() {
    return this._readBelongsToReflection({modelClass: SurveyStepElement, reflectionName: "survey_step_element"})
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  loadSurveyStepElement() {
    if (!("surveyStepElementId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepElementId")

    const id = this.surveyStepElementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey_step_element",
        model: this,
        modelClass: SurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  ensureSurveyStepElementLoaded() {
    return this.ensureAssociationLoaded("survey_step_element")
  }
}
